var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('banner-button');
import { breakpoints, theme } from '@shapeable/theme';
import { IconButton } from './icon-button';
import { withOwnProvider } from '../../utils/with-own-provider';
export var BannerButtonDefaultProps = {
  iconColor: 'light',
  backgroundColor: '#969696'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    z-index: 50;\n    background: #969696;\n    justify-content: center;\n    padding: ", ";\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    &:hover {\n      background: #666; \n    }\n\n    svg {\n      height: 28px;\n      width: 28px;\n      ", ";\n    }\n\n    &:active, &:hover {\n      svg {\n        ", ";\n      }\n    }\n  "], ["\n    position: relative;\n    z-index: 50;\n    background: #969696;\n    justify-content: center;\n    padding: ", ";\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    &:hover {\n      background: #666; \n    }\n\n    svg {\n      height: 28px;\n      width: 28px;\n      ", ";\n    }\n\n    &:active, &:hover {\n      svg {\n        ", ";\n      }\n    }\n  "])), theme.UNIT(2), theme.FILL('light'), theme.FILL('light')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    svg {\n      height: 36px;\n      width: 36px;\n    }\n  "], ["\n    svg {\n      height: 36px;\n      width: 36px;\n    }\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled(IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var BannerButtonComponent = function BannerButtonComponent(props) {
  var className = props.className,
      backgroundColor = props.backgroundColor,
      children = props.children,
      rest = __rest(props, ["className", "backgroundColor", "children"]);

  return React.createElement(My.Container, __assign({}, rest, {
    _bg: backgroundColor,
    className: cls.name(className)
  }), children);
};
export var BannerButton = withOwnProvider(BannerButtonComponent);
BannerButton.defaultProps = BannerButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;